module.exports = __webpack_public_path__ + "img/fox.b49c8528.svg";